import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'environments/environment';

export interface AuditLogRequest {
  usuario: string;
  accion: string;
  fechaHora: string;
  seccion: string;
  sistema: string;
}

export interface AuditLogResponse {
  success: boolean;
  status: number;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class AuditService {
  private baseUrl = environment.apiUrls.auditService;

  constructor(private http: HttpClient) {}

  private headers(locationPath: string = '/v1/audit'): HttpHeaders {
    return new HttpHeaders({
      'message-id':
        (crypto as any)?.randomUUID?.() ?? Math.random().toString(36).slice(2),
      location: locationPath || '/v1/audit',
    });
  }

  private validatePayload(payload: AuditLogRequest): string | null {
    if (!payload) return 'Payload requerido';
    const { usuario, accion, fechaHora, seccion, sistema } = payload;
    if (!usuario) return 'usuario es requerido';
    if (!accion) return 'accion es requerida';
    if (!fechaHora) return 'fechaHora es requerida';
    if (!seccion) return 'seccion es requerida';
    if (!sistema) return 'sistema es requerido';
    return null;
  }

  sendAuditLog(payload: AuditLogRequest): Observable<AuditLogResponse> {
    const validationError = this.validatePayload(payload);
    if (validationError) return throwError(() => new Error(validationError));

    const url = `${this.baseUrl}/v1/audit`;
    const headers = this.headers('/v1/audit');
    return this.http.post<AuditLogResponse>(url, payload, { headers });
  }
}


